import React from "react";
import { Clock, Edit2 } from "lucide-react";
import { DataTable } from "@/components/ui/DataTable";
import { ATTENDANCE_STATUS_LABELS, ATTENDANCE_STATUS_COLORS } from "../../constants/hrConstants";

export function AttendanceTable({ records, onEdit, employees = [] }) {
  if (!records.length) {
    return (
      <div className="bg-white rounded-xl border border-slate-100 p-12 text-center">
        <Clock className="w-10 h-10 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500 font-medium text-[13px]">No attendance records</p>
        <p className="text-slate-400 text-[12px] mt-1">Mark attendance for employees</p>
      </div>
    );
  }

  const today = new Date().toISOString().split("T")[0];

  const columns = [
    {
      header: "Employee",
      key: "employeeName",
      render: (r) => {
        const emp = employees.find((e) => e.id === r.employeeId);
        return (
          <div className="flex flex-col min-w-[150px]">
            <span className="text-sm font-medium text-slate-800 truncate" title={r.employeeName}>
              {r.employeeName}
            </span>
            <span className="text-[11px] text-slate-500 truncate mt-0.5">
              {emp?.phone || "—"} <span className="mx-1 text-slate-300">|</span> {emp?.email?.toLowerCase() || "—"}
            </span>
          </div>
        );
      },
    },
    {
      header: "Emp ID",
      key: "employeeId",
      render: (r) => <span className="text-xs font-mono font-semibold text-slate-500 truncate">{r.employeeId}</span>
    },
    {
      header: "Status",
      key: "status",
      render: (r) => {
        const status = r.status || (r.checkIn ? "present" : "absent");
        return <span className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${ATTENDANCE_STATUS_COLORS[status] || "bg-slate-100 text-slate-600"}`}>{ATTENDANCE_STATUS_LABELS[status] || status}</span>;
      },
    },
    {
      header: "Check In",
      key: "checkIn",
      render: (r) => <span className="text-sm font-medium text-slate-600 truncate">{r.checkIn || "—"}</span>
    },
    {
      header: "Check Out",
      key: "checkOut",
      render: (r) => <span className="text-sm font-medium text-slate-600 truncate">{r.checkOut || "—"}</span>
    },
    {
      header: "Remarks",
      key: "remarks",
      render: (r) => <span className="text-xs text-slate-500 truncate" title={r.remarks}>{r.remarks || "—"}</span>
    },
    {
      header: "",
      key: "actions",
      className: "w-[60px]",
      render: (r) => {
        if (r.date === today) {
          return (
            <div className="flex items-center justify-end pr-4">
              <button
                onClick={(e) => { e.stopPropagation(); onEdit(r); }}
                className="w-8 h-8 rounded-full inline-flex items-center justify-center border border-slate-200 text-slate-400 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-colors"
                title="Edit Entry"
              >
                <Edit2 className="w-4 h-4" />
              </button>
            </div>
          );
        }
        return null;
      }
    }
  ];

  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-sm">
      <DataTable columns={columns} data={records} tableClassName="min-w-[800px]" />
    </div>
  );
}
